import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import './index.scss';


export default function StepperComponent({ steps, activeStep = 0 }) {
  return (
    <Box className="container-stepper-component">
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel className='label'>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}
